<div class="center-limited">
  <equine-ui-nx-bt-ach-accounts
    [paymentMethods]="paymentMethods"
    [verificationOnly]="true"
    (verified)="openVerificationDialog($event)"
  ></equine-ui-nx-bt-ach-accounts>
</div>
